import { Controller } from "@hotwired/stimulus"

export default class AdminSubCardController extends Controller {
  showModal() {
    let data = event.currentTarget.dataset
    let modal = document.getElementById("usage-update-modal")
    modal.dataset.usageUpdateModalUsageValue = JSON.stringify(data)
    modal.querySelector("input#usage-value").value = data.usageValue
    modal.querySelector("#product-name").textContent = data.productName
    modal.querySelector("#sub-name").textContent = data.subName
    modal.showModal()
  }
}
